// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
CloudZap by Cloud Serve Pvt. Ltd
*/

.nav-item{
    text-decoration: none;
    color: #222;
    font-size: 1.2rem;
    font-weight: 600;
    padding: 0.7rem 1rem;
    white-space: nowrap;
}
.nav-item:hover{
    background-color: #fff;
    color: skyblue;
    border-radius: 4px;
    transition: all 0.2s ease-in-out;  
}
.NavbarItems {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.25);
  width: 95%;
  height: 80px;
  border-radius: 13px;
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translate(-50%);
  z-index: 9999;
}

.navbar-logo {
  color: #222;
  font-size: 2rem;
  cursor: pointer;
}
.nav-menu {
  display: grid;
  grid-template-columns: repeat(6, auto);
  grid-gap: 10px;
  list-style: none;
  align-items: center;
  margin-top: 10px;
}
.nav-links {
  text-decoration: none;
  color: #222;
  font-size: 1.2rem;
  font-weight: 600;
  padding: 0.7rem 1rem;
  white-space: nowrap;
 
}
.nav-links:hover {
 /*background-color: skyblue;*/
  color: skyblue;
  border-radius: 4px;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
}
.nav-links-mobile {
  display: none;
}
button {
  padding: 0.5rem 1rem;
  white-space: nowrap;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease-in-out;
  background-color: skyblue;
}

button:hover {
 /* background-color: #222;*/
  color: #fff;
}

.menu-icons {
  display: none;
}
.logo img{
  width:75px;
  /* background-color: #3b5998; */
  justify-content: start;
  height:59px;
  align-items: center;
  border-radius: 6px;
}
@media screen and (max-width:340px){
  .NavbarItems{
       max-width:60%;
       align-items:left;
  }
}
@media screen and (max-width: 850px) {
  .NavbarItems {
    z-index: 99;
    
  }
  
  .nav-menu {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background: #fff;
    width: 100%;
    height: auto;
    position: absolute;
    top: 0;
    left: -100%;
    opacity: 0;
    align-items: stretch;
    padding: 80px 0 30px 0;
    margin: 0;
    z-index: -1;
    transition: 0.3s ease-in-out;
    border-radius: 13px;
  }
  .nav-menu.active {
    left: 0;
    opacity: 1;
    z-index: -1;
    transition: 0.3s ease-in-out;
  }
  .nav-links {
    text-decoration: none;
    display: block;
    width: 100%;
    font-size: 1.2rem;
    padding: 2rem 0;
  }
  .nav-links:hover {
    text-decoration: none;
    color:skyblue ;
    transition: none;
  }
  button {
    text-decoration: none;
    color:#fff;
    display: block;
  }
  button:hover {
   color: #222;
    text-decoration: none;
  }
  .nav-links-mobile {
    display: block;
    text-align: center;
    padding: 1.5rem;
    margin: auto;
    border-radius: 4px;
    width: 80%;
    background: #dec;
    text-decoration: none;
    color: #222;
    font-size: 1.2rem;
    font-weight: 700;
    letter-spacing: 2px;
  }
  .menu-icons {
    display: block;
    cursor: pointer;
  }
  .menu-icons i {
    font-size: 1.2 rem;
    color: #222;
  }

}
`, "",{"version":3,"sources":["webpack://./src/components/navbar.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;IACI,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,gCAAgC;AACpC;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,4CAA4C;EAC5C,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,SAAS;EACT,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;;AAErB;AACA;CACC,6BAA6B;EAC5B,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;AAClC;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;CACC,2BAA2B;EAC1B,WAAW;AACb;;AAEA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,+BAA+B;EAC/B,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE;OACK,aAAa;OACb,gBAAgB;EACrB;AACF;AACA;EACE;IACE,WAAW;;EAEb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,UAAU;IACV,oBAAoB;IACpB,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,4BAA4B;IAC5B,mBAAmB;EACrB;EACA;IACE,OAAO;IACP,UAAU;IACV,WAAW;IACX,4BAA4B;EAC9B;EACA;IACE,qBAAqB;IACrB,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,qBAAqB;IACrB,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,UAAU;IACV,cAAc;EAChB;EACA;GACC,WAAW;IACV,qBAAqB;EACvB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;;AAEF","sourcesContent":["/*\r\nCloudZap by Cloud Serve Pvt. Ltd\r\n*/\r\n\r\n.nav-item{\r\n    text-decoration: none;\r\n    color: #222;\r\n    font-size: 1.2rem;\r\n    font-weight: 600;\r\n    padding: 0.7rem 1rem;\r\n    white-space: nowrap;\r\n}\r\n.nav-item:hover{\r\n    background-color: #fff;\r\n    color: skyblue;\r\n    border-radius: 4px;\r\n    transition: all 0.2s ease-in-out;  \r\n}\r\n.NavbarItems {\r\n  background-color: #fff;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0 30px;\r\n  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.25);\r\n  width: 95%;\r\n  height: 80px;\r\n  border-radius: 13px;\r\n  position: fixed;\r\n  top: 20px;\r\n  left: 50%;\r\n  transform: translate(-50%);\r\n  z-index: 9999;\r\n}\r\n\r\n.navbar-logo {\r\n  color: #222;\r\n  font-size: 2rem;\r\n  cursor: pointer;\r\n}\r\n.nav-menu {\r\n  display: grid;\r\n  grid-template-columns: repeat(6, auto);\r\n  grid-gap: 10px;\r\n  list-style: none;\r\n  align-items: center;\r\n  margin-top: 10px;\r\n}\r\n.nav-links {\r\n  text-decoration: none;\r\n  color: #222;\r\n  font-size: 1.2rem;\r\n  font-weight: 600;\r\n  padding: 0.7rem 1rem;\r\n  white-space: nowrap;\r\n \r\n}\r\n.nav-links:hover {\r\n /*background-color: skyblue;*/\r\n  color: skyblue;\r\n  border-radius: 4px;\r\n  text-decoration: none;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n.nav-links-mobile {\r\n  display: none;\r\n}\r\nbutton {\r\n  padding: 0.5rem 1rem;\r\n  white-space: nowrap;\r\n  border-radius: 6px;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: 0.2s ease-in-out;\r\n  background-color: skyblue;\r\n}\r\n\r\nbutton:hover {\r\n /* background-color: #222;*/\r\n  color: #fff;\r\n}\r\n\r\n.menu-icons {\r\n  display: none;\r\n}\r\n.logo img{\r\n  width:75px;\r\n  /* background-color: #3b5998; */\r\n  justify-content: start;\r\n  height:59px;\r\n  align-items: center;\r\n  border-radius: 6px;\r\n}\r\n@media screen and (max-width:340px){\r\n  .NavbarItems{\r\n       max-width:60%;\r\n       align-items:left;\r\n  }\r\n}\r\n@media screen and (max-width: 850px) {\r\n  .NavbarItems {\r\n    z-index: 99;\r\n    \r\n  }\r\n  \r\n  .nav-menu {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    background: #fff;\r\n    width: 100%;\r\n    height: auto;\r\n    position: absolute;\r\n    top: 0;\r\n    left: -100%;\r\n    opacity: 0;\r\n    align-items: stretch;\r\n    padding: 80px 0 30px 0;\r\n    margin: 0;\r\n    z-index: -1;\r\n    transition: 0.3s ease-in-out;\r\n    border-radius: 13px;\r\n  }\r\n  .nav-menu.active {\r\n    left: 0;\r\n    opacity: 1;\r\n    z-index: -1;\r\n    transition: 0.3s ease-in-out;\r\n  }\r\n  .nav-links {\r\n    text-decoration: none;\r\n    display: block;\r\n    width: 100%;\r\n    font-size: 1.2rem;\r\n    padding: 2rem 0;\r\n  }\r\n  .nav-links:hover {\r\n    text-decoration: none;\r\n    color:skyblue ;\r\n    transition: none;\r\n  }\r\n  button {\r\n    text-decoration: none;\r\n    color:#fff;\r\n    display: block;\r\n  }\r\n  button:hover {\r\n   color: #222;\r\n    text-decoration: none;\r\n  }\r\n  .nav-links-mobile {\r\n    display: block;\r\n    text-align: center;\r\n    padding: 1.5rem;\r\n    margin: auto;\r\n    border-radius: 4px;\r\n    width: 80%;\r\n    background: #dec;\r\n    text-decoration: none;\r\n    color: #222;\r\n    font-size: 1.2rem;\r\n    font-weight: 700;\r\n    letter-spacing: 2px;\r\n  }\r\n  .menu-icons {\r\n    display: block;\r\n    cursor: pointer;\r\n  }\r\n  .menu-icons i {\r\n    font-size: 1.2 rem;\r\n    color: #222;\r\n  }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
